import gql from 'graphql-tag'

export default gql`{
	system_settings{
    id
    description
    setting_type_id
    setting_value
  }
}`